import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  DeleteIcon, DirectDepositIcon, EditIcon, KycApproveIcon, KycDone, PlusIcon2, StripeIcon, WireTransferIcon,
} from "../../../../../assets/icons/svgicons";
import dummyProfile from "../../../../../assets/images/dummy-profile.png";
import Button from "../../../../common/Button/Button";
import AddPaymentMethod from "../../../../common/Modals/AddPaymentMethod/AddPaymentMethod";
import DeleteProfile from "../../../../common/Modals/DeleteProfile/DeleteProfile";
import DirectDeposit from "../../../../common/Modals/DirectDeposit/DirectDeposit";
import EditProfile from "../../../../common/Modals/EditProfile/EditProfile";
import LegalDisclosures from "../../../../common/Modals/LegalDisclosures/LegalDisclosures";
import NoContent from "../../../../common/NoContent/NoContent";
import MyProfileShimmer from "./MyProfileShimmer/MyProfileShimmer";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";

import {
  getUserInfoAction, deactivateAccountAction, addBankDetailsAction, fetchBankDetailsAction, getBankDetailsAction, getUserProfitAction,
} from "../../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import AddBankDetails from "../../../../common/Modals/AddBankDetails/AddBankDetails";
import { EyeIcon } from "../../../../../assets/icons/svgicons";
import profileBg from '../../../../../assets/images/profileBg.svg';
import styles from "./MyProfile.module.scss";
import { useLocation } from "react-router-dom";


const MyProfile = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState([]);
  const [bankDetail, setBankDetails] = useState([]);
  const [show, setShow] = useState(false);
  const [directdeposit, setDirectDeposit] = useState(false);
  const [legaldisclosures, setLegalDisclosures] = useState(false);
  const [showDeleteProfile, setShowDeleteProfile] = useState(false);
  const [showAddMethods, setShowAddMethods] = useState(false);
  const [showAddBankDetails, setShowAddBankDetails] = useState(false);
  const [shippingAddress, setShippingAddress] = useState();
  const [billingAddress, setBillingAddress] = useState();
  const [eqityProfit, setEquityProfit] = useState();

  const [isApiVisible, setIsApiVisible] = useState(false); // State for toggling visibility

  const paymentIcons = {
    STRIPE: <StripeIcon />,
    DIRECTDEPOSIT: <DirectDepositIcon />,
    WIRETRANSFER: <WireTransferIcon />,
  };
  useEffect(() => {
    if (!loading && location.hash === "#bank-details") {
      const element = document.getElementById("bank-details");

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [loading, location.hash]);

  const getUserProfile = async () => {
    try {
      const response = await dispatch(getUserInfoAction());
      if (response?.status === 200) {
        const userData = response.data.data;
        setUser(userData);
        if (userData.addressList.length === 0) {
          setBillingAddress({});
          setShippingAddress({});
        } else if (userData.addressList.length === 1) {
          setBillingAddress(userData.addressList[0]);
          setShippingAddress(userData.addressList[0]);
        } else {
          setBillingAddress(userData.addressList[1]);
          setShippingAddress(userData.addressList[0]);
        }
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const getUserProfit = async () => {
    try {
      const response = await dispatch(getUserProfitAction());
      if (response?.status === 200) {
        setEquityProfit(response.data.data.profitData.value);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const getBankDetails = async () => {
    try {
      const response = await dispatch(getBankDetailsAction());
      if (response?.status === 200) {
        const details = response.data.data;
        setBankDetails(details);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const handleDeactivateAccount = async () => {
    try {
      await dispatch(deactivateAccountAction());
    } catch (error) {
      console.log("Error deactivating account:", error);
    }
  };

  useEffect(() => {
    getUserProfile();
    getBankDetails();
    getUserProfit();
    setTimeout(() => {
      setLoading(false);
    }, 1400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <MyProfileShimmer />
      ) : (
        <>
          <div className={styles.profile}>
            <div className={styles.profile_box}>
              <div className={styles.profile_header}>
                <div className={styles.profile_header_content}>
                  <h4>Personal Info.</h4>
                  <p>Update your photo, address and personal details here.</p>
                </div>
                <div className={styles.profile_header_action}>
                  <Button
                    variant="small_size"
                    className={styles.profile_header_action_btn}
                    onClick={() => setShow(true)}
                  >
                    <span>Edit Details</span> <EditIcon />
                  </Button>
                </div>
              </div>
              <div
                className={`${styles.profile_box_body} ${styles.profile_box_bodyinner}`}
              >
                <div className={styles.profile_box_bodyinner_topbgimg}>
                  <img src={profileBg} alt="bg-img" />
                </div>
                <div className={styles.profile_detailsbox}>
                  <div className={styles.profile_imagebox}>
                    <div className={styles.profile_img}>
                      <img
                        src={
                          user?.profile_pic
                            ? user?.profile_url + "" + user?.profile_pic
                            : dummyProfile
                        }
                        alt=""
                      />
                      {user?.kyc_status === "APPROVED" ? (
                        <span className={`${styles.kyc_badge}`}>
                          <KycApproveIcon />
                        </span>
                      ) : (
                        <span className={`${styles.kyc_badge}`}>
                          {user?.kyc_status}
                        </span>
                      )}
                    </div>
                  </div>
                  {user?.kyc_status === "APPROVED" ? (
                    <h6 className={`${styles.profile_status} ${styles.kyc_verifed}`}>
                      {user?.kyc_status}
                    </h6>
                  ) : user?.kyc_status === "PENDING" ? (
                    <h6 className={`${styles.profile_status} ${styles.kyc_inprocess}`}>
                      {user?.kyc_status}
                    </h6>
                  ) : (
                    <h6 className={`${styles.profile_status} ${styles.kyc_rejected}`}>
                      {user?.kyc_status}
                    </h6>
                  )}
                </div>

                {/* --- Updated section starts here --- */}
                <div className={styles.profile_alldetails}>
                  {/* Column 1: Personal Info */}
                  <div className={styles.profile_details}>
                    <ul>
                      <li className="mt-0">
                        Username: <span>{user?.username}</span>
                      </li>
                      <li>
                        User ID: <span>
                          <Tooltip
                            icon={<span>{user?.user_uid || "-"}</span>}
                            content={
                              <>
                                <CopyBtn text={user?.user_uid} /> {user?.user_uid}
                              </>
                            }
                          />
                        </span>
                      </li>
                      <li>
                        Email: <span>{user?.email}</span>
                      </li>
                      {user?.is_market_maker === 1 && (
                        <li>
                          Market Maker Key:{" "}
                          <span>
                            {isApiVisible
                              ? user?.user_market_info?.api_token || "-"
                              : "••••••••••••"}{" "}
                            <button onClick={() => setIsApiVisible(!isApiVisible)}>
                              <EyeIcon isVisible={isApiVisible} />{" "}
                            </button>
                          </span>
                        </li>
                      )}
                    </ul>
                  </div>

                  {/* Column 2: Shipping Address */}
                  <div className={styles.profile_details}>
                    <h6>Shipping Address</h6>
                    <ul>
                      <li>Address: <span>{shippingAddress?.address || "-"}</span></li>
                      <li>
                        City/State:{" "}
                        <span>
                          {shippingAddress?.city
                            ? `${shippingAddress.city}/${JSON.parse(shippingAddress.state).name}`
                            : "-"}
                        </span>
                      </li>
                      <li>
                        Country:{" "}
                        <span>
                          {shippingAddress?.country
                            ? JSON.parse(shippingAddress.country).name
                            : "-"}
                        </span>
                      </li>
                      <li>Zip Code: <span>{shippingAddress?.zip_code || "-"}</span></li>
                    </ul>
                  </div>

                  {/* Column 3: Billing Address */}
                  <div className={styles.profile_details}>
                    <h6>Billing Address</h6>
                    <ul>
                      <li>Address: <span>{billingAddress?.address || "-"}</span></li>
                      <li>
                        City/State:{" "}
                        <span>
                          {billingAddress?.city
                            ? `${billingAddress.city}/${JSON.parse(billingAddress.state).name}`
                            : "-"}
                        </span>
                      </li>
                      <li>
                        Country:{" "}
                        <span>
                          {billingAddress?.country
                            ? JSON.parse(billingAddress.country).name
                            : "-"}
                        </span>
                      </li>
                      <li>Zip Code: <span>{billingAddress?.zip_code || "-"}</span></li>
                    </ul>
                  </div>
                </div>
                {/* --- Updated section ends here --- */}
              </div>
            </div>

            {/* Other boxes (Payment, Bank, etc.) remain unchanged */}
            <div className={styles.profile_box}>
              <div className={styles.profile_header}>
                <div className={styles.profile_header_content}>
                  <h4>Payment Method</h4>
                  <p>Add your payment details here.</p>
                </div>
                <div className={styles.profile_header_action}>
                  <Button
                    variant="small_size"
                    className={`${styles.profile_header_action_btn} ${styles.add_btn}`}
                    onClick={() => setShowAddMethods(true)}
                  >
                    <span>Add method</span> <PlusIcon2 />
                  </Button>
                </div>
              </div>
              <div className={`${styles.profile_box_body} ${styles.profile_box_body_payment}`}>
                <Row>
                  {user?.paymentMethods?.length > 0 ? (
                    user?.paymentMethods?.map(
                      (item) =>
                        item?.is_active === 1 && (
                          <Col md={4} key={item?.type}>
                            <div className={styles.payment_method}>
                              <div className={styles.payment_method_header}>
                                <span className={styles.payment_icon}>
                                  {paymentIcons[item?.type.replace(" ", "")]}
                                </span>
                                {item?.isNew && (
                                  <span className={styles.new_badge}>New</span>
                                )}
                              </div>
                              <div>
                                <h4>{item?.type}</h4>
                                <p>{item?.method_detail}</p>
                                <h4>{item?.maximum_limit}</h4>
                              </div>
                            </div>
                          </Col>
                        )
                    )
                  ) : (
                    <Col md={12}>
                      <NoContent
                        className={styles.no_payment_method}
                        content="It looks like you're just getting started on your investment journey."
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>

            <div className={styles.profile_box} id="bank-details">
              <div className={styles.profile_header}>
                <div className={styles.profile_header_content}>
                  <h4>Bank Details</h4>
                  <p>Update your bank details here.</p>
                </div>
                <div className={styles.profile_header_action}>
                  <Button
                    variant="small_size"
                    className={styles.profile_header_action_btn}
                    onClick={() => setShowAddBankDetails(true)}
                  >
                    <span>
                      {Object.keys(bankDetail).length > 0 ? "Edit" : "Add"} Bank Details
                    </span>{" "}
                    <EditIcon />
                  </Button>
                </div>
              </div>
              <div className={styles.profile_box_body}>
                {Object.keys(bankDetail).length === 0 ? (
                  <NoContent
                    className={styles.no_payment_method}
                    variant="medium"
                    content="It looks like you're just getting started on your investment journey."
                  />
                ) : (
                  <>
                    <div className={styles.profile_details}>
                      <ul>
                        <li className="mt-0">
                          Account Holder Name:{" "}
                          <span>{bankDetail?.account_holder_name}</span>
                        </li>
                        <li>
                          Bank Name: <span>{bankDetail?.bank_name || "-"}</span>
                        </li>
                        <li>
                          Account Number:{" "}
                          <span>{bankDetail?.account_number}</span>
                        </li>
                      </ul>
                    </div>

                    <div className={styles.profile_details}>
                      <ul>
                        <li>
                          Routing Number:{" "}
                          <span>{bankDetail?.routing_number}</span>
                        </li>
                        <li>
                          IFSC Code:{" "}
                          <span>
                            {bankDetail?.ifsc_code ? bankDetail?.ifsc_code : "-"}
                          </span>
                        </li>
                        <li>
                          Account Type:
                          <span>{bankDetail?.account_type}</span>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className={styles.profile_box}>
              <div className={styles.profile_header}>
                <div className={styles.profile_header_content}>
                  <h5>Deactivate Account</h5>
                  <p>You can deactivate your account from here.</p>
                  <p className={styles.dangernot}>
                    *Notice: Before you close and deactivate your STBL account,
                    please withdraw all assets you have on the platform or in your STBL Wallet.
                  </p>
                </div>
                <div className={`${styles.profile_header_action} ${styles.deactivate_btn}`}>
                  <Button
                    variant="small_size danger_filled"
                    className={styles.profile_header_action_btn}
                    onClick={() => setShowDeleteProfile(true)}
                  >
                    <span>Deactivate Account</span> <DeleteIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <DeleteProfile
        show={showDeleteProfile}
        handleClose={() => setShowDeleteProfile(false)}
        handleDeactivateAccount={handleDeactivateAccount}
      />
      <EditProfile
        show={show}
        handleClose={() => setShow(false)}
        userData={user}
        getUserProfile={() => getUserProfile()}
      />
      <DirectDeposit show={directdeposit} handleClose={() => setDirectDeposit(false)} />
      <LegalDisclosures show={legaldisclosures} handleClose={() => setLegalDisclosures(false)} />
      <AddPaymentMethod
        show={showAddMethods}
        handleShow={() => setShowAddMethods(true)}
        handleClose={() => setShowAddMethods(false)}
      />
      <AddBankDetails
        show={showAddBankDetails}
        handleClose={() => setShowAddBankDetails(false)}
        bankDetail={bankDetail}
        getBankDetails={getBankDetails}
      />
    </>
  );
};

export default MyProfile;
